import { Info, Tooltip } from '@weareopenr/component-library';

export const HFSSTooltip = () => (
  <Tooltip text="This classification affects how the product can be promoted under government HFSS regulations. Openr will share the classification with downstream aggregators when the product is published.">
    <Info />
  </Tooltip>
);
